export default "__VITE_ASSET__COhQhIY2__"